import { StateCreator } from 'zustand';

export type EntityReviewChangesState = {
    revisionId: number | undefined;
};
export const initialEntityReviewChangesState: EntityReviewChangesState = {
    revisionId: 0
};

export interface EntityReviewChangesSlice {
    entityReviewChanges: EntityReviewChangesState;
    setEntityReviewChanges: (data: EntityReviewChangesState) => void;
}

export const createEntityReviewChangesSlice: StateCreator<
    EntityReviewChangesSlice,
    [],
    [],
    EntityReviewChangesSlice
> = (set) => ({
    entityReviewChanges: { ...initialEntityReviewChangesState },
    setEntityReviewChanges: (entityReviewChangesData: EntityReviewChangesState) =>
        set(() => ({ entityReviewChanges: entityReviewChangesData }))
});
